import React from 'react';
import Badge from './ui/Badge';

const statusMap = {
  pending:   { variant: 'pending',   label: 'Pending' },
  accepted:  { variant: 'accepted',  label: 'Accepted' },
  completed: { variant: 'completed', label: 'Completed' },
  cancelled: { variant: 'cancelled', label: 'Cancelled' },
  cancellation_requested: { variant: 'cancellation_requested', label: 'Cancellation Requested' },
  open:      { variant: 'accepted',  label: 'Open' },
  closed:    { variant: 'completed', label: 'Closed' },
};

export default function OrderStatusBadge({ status }) {
  const config = statusMap[status] || { variant: 'default', label: status };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
